import * as types from "../../actions/types";

const initialState = {
  success: false,
  err: ''
}

export default function createAdsReducer(state = initialState, action) {
  switch (action.type) {
    case types.CREATE_NEW_ADS:
      return {
        ...state,
        success: action.success
      }
    case types.CREATE_NEW_ADS_ERR:
      return {
        ...state,
        err: action.err
      }
    default:
      return state
  }
}